import * as React from "react";

type EditorChecklistBannerProps = {
  style: React.CSSProperties;
};

const EditorChecklistBanner = React.forwardRef<
  HTMLDivElement,
  EditorChecklistBannerProps
>((props, ref) => {
  // Get version and project id from URL
  const urlParams = new URLSearchParams(window.location.search);
  const versionId = window.location.pathname.split("/")[2];
  const projectId = urlParams.get("project_id");

  // Construct the URL for the editor checklist
  const checklistUrl = `/versions/${versionId}/editor_checklist?project_id=${projectId}`;

  return (
    <div
      ref={ref}
      className="editor-checklist-banner-container"
      style={props.style}
    >
      <span className="editor-checklist-banner-text">
        Done editing? Don't forget the checklist! This notifies the next editor.
      </span>
      <a
        href={checklistUrl}
        target="_blank"
        className="editor-checklist-banner-button"
      >
        <span className="editor-checklist-banner-button-text">
          Open Editor's Checklist
        </span>
        <i className="fa-solid fa-up-right-from-square editor-checklist-banner-button-icon"></i>
      </a>
    </div>
  );
});

export default EditorChecklistBanner;
